import React from 'react';
import { BrowserRouter as Router, Route, Switch, Redirect } from 'react-router-dom';

import AddHeaderToComponent from '../components/Header';
import FrontPricing from '../pages/FrontPricing';
import BackPricing from '../pages/BackPricing';
import HomePricing from '../pages/HomePricing';
import PricingTabs from '../pages/PricingTabs';
import CheckoutTabs from '../pages/CheckoutTabs';
import CheckoutForm from '../pages/CheckoutForm';
import PeacockSelection from '../pages/PeacockSelection';
import PeacockCheckout from '../pages/PeacockCheckout';
import NotFound from '../pages/NotFound';

const AppRouter = () => (
  <Router>
    <Switch>
      <Route
        path="/peacock/:leadSource"
        component={props => AddHeaderToComponent(PeacockSelection, false, { ...props }, true, true)}
      />
      <Route
        path="/peacock-upshow"
        component={props =>
          AddHeaderToComponent(PeacockSelection, false, { ...props, oldSource: 'Self Sign-Up: Peacock' }, true, true)
        }
      />
      <Route path="/peacock-joehand" component={() => <Redirect to="/peacock-upshow" />} />
      <Route path="/peacock-checkout" component={PeacockCheckout} />
      <Route path="/frontofhouse" component={props => AddHeaderToComponent(FrontPricing, false, props)} />
      <Route path="/backofhouse" component={props => AddHeaderToComponent(BackPricing, false, props)} />
      <Route path="/homepricing" component={props => AddHeaderToComponent(PricingTabs, false, props)} />
      <Route path="/checkout" component={props => AddHeaderToComponent(CheckoutTabs, false, props)} />
      <Route path="/checkoutForm" component={props => AddHeaderToComponent(CheckoutForm, false, props)} />
      <Route path="/404" component={NotFound} />
      <Route exact path="/" component={props => AddHeaderToComponent(HomePricing, true, props, true)} />
    </Switch>
  </Router>
);

export default AppRouter;
